import React, { Children, Component } from 'react';
import { motion } from 'framer-motion';
import { InfinityIcon, ClockIcon, ZapIcon, RefreshCwIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
const benefits = [{
  icon: InfinityIcon,
  title: 'Acceso de por vida',
  description: 'Una vez que compras, el curso es tuyo para siempre. Sin pagos mensuales.'
}, {
  icon: ClockIcon,
  title: 'Aprende a tu ritmo',
  description: 'Estudia cuando quieras, donde quieras. Sin horarios fijos ni presiones.'
}, {
  icon: RefreshCwIcon,
  title: 'Actualizaciones gratuitas',
  description: 'Recibe todas las actualizaciones futuras sin costo adicional.'
}];
export function BenefitsSection() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-14">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-15">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} data-id="element-16">
          {/* Section header */}
          <motion.div variants={itemVariants} className="mb-16 text-center" data-id="element-17">
            <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-electric-blue/10 to-bright-orange/10 px-4 py-2 text-sm font-semibold text-electric-blue" data-id="element-18">
              <ZapIcon className="h-4 w-4" data-id="element-19" />
              Lo que incluye
            </span>
            <h2 className="font-heading text-3xl font-extrabold text-gray-900 sm:text-4xl md:text-5xl" data-id="element-20">
              Beneficios del Curso
            </h2>
          </motion.div>

          {/* Benefits grid */}
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-21">
            {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return <motion.div key={index} variants={itemVariants} whileHover={{
              y: -8,
              scale: 1.02,
              transition: {
                duration: 0.2
              }
            }} className="group cursor-default rounded-2xl bg-white p-8 shadow-lg transition-shadow duration-300 hover:shadow-2xl" data-id="element-22">
                  <div className="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-electric-blue/10 to-bright-orange/10 transition-all duration-300 group-hover:from-electric-blue group-hover:to-bright-orange" data-id="element-23">
                    <IconComponent className="h-7 w-7 text-electric-blue transition-colors duration-300 group-hover:text-white" data-id="element-24" />
                  </div>
                  <h3 className="mb-2 font-heading text-xl font-bold text-gray-900" data-id="element-25">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-26">{benefit.description}</p>
                </motion.div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}